import React, { useState, useEffect } from 'react';
import io from "socket.io-client";

const two = (n) => String(n).padStart(2, '0');

// La cuenta atras la lleva el servidor (apps/streamClock.js): manda lo que queda al conectar y
// cada vez que cambia (empieza, se alarga o se acaba el directo). null = sin directo.
const StreamTimeCounter = () => {
    const [endsAt, setEndsAt] = useState(null);
    const [, setTick] = useState(0);

    useEffect(() => {
        const socket = io('https://forallia.com');
        socket.on('streamEnd', (remainingMs) => setEndsAt(remainingMs === null ? null : Date.now() + remainingMs));
        const id = setInterval(() => setTick(t => t + 1), 1000);
        return () => {
            clearInterval(id);
            socket.close();
        };
    }, []);

    const left = Math.max(0, Math.floor((endsAt - Date.now()) / 1000));

    return (
            <div className="countdown heroes">
                {endsAt !== null ? (
                    <h2>Tiempo restante de Stream <span>{two(Math.floor(left / 3600))}:{two(Math.floor(left / 60) % 60)}:{two(left % 60)}</span></h2>
                ) : (
                    <h2>Stream offline</h2>
                )}
            </div>
    )
}

export default StreamTimeCounter;
